import { TbBuildingAirport } from "react-icons/tb";

import { softColors } from "./colors";

export enum Airpots {
    IST = "IST",
    SAW = "SAW",
}
export const airpots = [
    {
        value: Airpots.IST,
        img: "/images/IST.webp",
        tooltip: {
            title: "İGA  İstanbul Havalimanı",
            description: "Avrupa Yakası'nda bulunan şehrin ana uluslararası havalimanıdır.",
        },
        label: "IST_desc",
        ...softColors.brown,
        component: () => TbBuildingAirport,
        values: [Airpots.IST, 99157],
    },
    {
        value: Airpots.SAW,
        img: "/images/SAW.png",
        tooltip: {
            title: "Sabiha Gökçen Havalimanı",
            description: "Anadolu Yakası'nda yer alan ikinci büyük havalimanıdır.",
        },
        label: `SAW_desc`,
        ...softColors.brown,
        component: () => TbBuildingAirport,
        values: [Airpots.SAW, 99102],
    },
];
